import moment from 'moment-timezone';

moment.locale('ru');

export function dateTime(date) {
  return date && moment(date).tz('Europe/Moscow').format('D MMMM HH:mm МСК') || '';
}

export function dateTimeYear(date) {
  return date && moment(date).tz('Europe/Moscow').format('D MMMM YYYY, HH:mm МСК') || '';
}



// WEBPACK FOOTER //
// ./src/components/DateFormats.js